<template>
    <form class="add-article-wrapper form" @submit.prevent="submit">
        <section class="add-article-section add-article-section--heading">
            <div class="add-article-details">
                <div class="form-elements">
                    <div class="form-element">
                        <div class="wrap-title">
                            <input
                                    id="title"
                                    type="text"
                                    name="title"
                                    v-model="page.title"
                                    v-validate="'required'"
                                    placeholder="Type in to add title..."
                                    class="form-control"/>
                            <div v-if="errors.has('title')"
                                 class="form-errors">{{ errors.first('title') }}
                            </div>
                        </div>
                    </div>
                </div>
            <div class="control-panel">
                <div class="wrap-button">
                    <button type="button" @click="deletePage()" >
                        <icon name="remove" class="icon-btn-ctr"></icon>
                        <span>Delete page</span>
                    </button>
                </div>
            </div>
            <statusbar :status="page.status" :updatedAt="updatedAt"></statusbar>

            </div>
        </section>
        <div class="add-article-body">
            <!-- .add-article-sections -->
            <div class="add-article-sections">
                <section class="add-article-section">
                    <h2 class="add-article-section__title">Title and body</h2>
                    <vue-editor
                            :editorToolbar="editorToolbar"
                            name="content"
                            class="article-editor"
                            v-model="page.content.content"
                    />
                    <div v-if="errors.has('description')" class="form-errors">
                        {{ errors.first('content') }}
                    </div>
                </section>
            </div>
            <div class="add-article-actions">
                <button type="button" @click="$router.push('/admin/articles-list')" class="action-btn--back">
                    <icon name="rotate-left"></icon>
                    Back to list
                </button>
                <button type="button" class="action-btn action-btn--preview icon-btn" @click="preview()">
                    <!--<icon name="eye" />-->
                    <span class="icon-button"><img class="previe-icon"
                                                   src="../../../assets/img/main/previeIcon.png"></span>
                    <span class="textInButton">Preview page</span>
                </button>
                <button type="button" class="action-btn action-btn--exit icon-btn"
                        @click="$router.push('/admin/static-pages')">
                        <span class="icon-button"><img class="export-icon"
                                                       src="../../../assets/img/main/export.png"></span>Exit without saving
                </button>
                <button type="button" class="action-btn action-btn--draft icon-btn" @click="saveDraft()">
                        <span class="icon-button"><img class="saveAndDraft-icon"
                                                       src="../../../assets/img/main/saveAndDraft.png"></span>Save as draft
                </button>
                <button type="submit" class="action-btn action-btn--publish icon-btn" @click.prevent="publish()">
                    <span class="icon-button"><img class="earth-icon" src="../../../assets/img/main/earth.png"></span>Publish page
                </button>
            </div>
        </div>
    </form>

</template>

<script>
  import api from '@/api'
  import statusbar from '@/components/admin/common/statusbar'

  export default {
    name: 'staticpage',
    data () {
      return {
        page: {
          title: '',
          content: {},
          status: 0
        },
        editorToolbar: [
          [{'header': [2, 3, 4, 5, 6, false]}],
          ['bold', 'italic', 'underline', 'strike', {'color': []}, {'background': []}],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          ['blockquote', 'code-block', 'image', 'link'],
          [{'font': []}],
          [{'align': []}],
          ['clean']
        ],
        isNew: true,
        id: null,
        type: 'page',
        updatedAt: null
      }
    },
    methods: {
      submit () {
        return false
      },
      preview () {
        if (this.errors.items.length > 0) return
        this.page.status = 0
        this.sendRequest(this.page).then((res) => {
          window.open('https://google.com', '_blank')
        })
      },
      exit () {
        alert(321)
      },
      deletePage () {
        alert('Delete')
      },
      saveDraft () {
        if (this.errors.items.length > 0) return
        this.page.status = 0
        this.sendRequest(this.page)
      },
      publish () {
        if (this.errors.items.length > 0) return
        this.page.status = 1
        this.sendRequest(this.page)
      },
      getUrl () {
        if (this.isNew) {
          return api.URLS.page + '/' + this.type
        }
        return api.URLS.page + '/' + this.type + '/' + this.id
      },
      sendRequest (payload) {
        if (this.isNew) {
          return this.$http.post(this.getUrl(), payload, api.headersAuthSettings)
        }
        return this.$http.post(this.getUrl(), payload, api.headersAuthSettings)
      },
      fetchPage () {
        this.$http.get(api.URLS.page + '/' + this.id, api.headersAuthSettings)
          .then((res) => {
            this.page.title = res.body.title
            this.page.content.content = res.body.content.content
            this.updatedAt = new Date(res.body.updated_at)
          })
      }
    },
    mounted () {
      if (this.$route.params.id !== 0 && typeof this.$route.params.id !== 'undefined') {
        this.isNew = false
        this.id = this.$route.params.id
        this.fetchPage()
      }
    },
    components: {
      statusbar
    }
  }
</script>
<style src='@/assets/scss/components/add-article.scss' lang='scss' scoped />
<style lang="scss" scoped>
    .add-article-details {
        width: 85%;
    }
    .control-panel button {
        width: 100%;
        text-align: left;
        padding: 10px 20px 10px 20px;
        color: #fff;
        margin-bottom: 10px;
        vertical-align: middle;
        background: #B70A37;
    }
</style>



// WEBPACK FOOTER //
// staticpage.vue?b52cd854